// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2g5lW","addWidgetButton":"Header_addWidgetButton__1iaQM","dashboardTabs":"Header_dashboardTabs__aeN1v","active":"Header_active__3bGTC"};